<template>
  <div class="contacts">
    <h1 class="seo-title">Документы и контакты</h1>
    <div class="wrapper">
      <Navigation />
      <div class="contacts__main">
        <p class="contacts__main__title">контакты</p>
        <p class="contacts__main__official" v-if="!isCountryFromRu($store.state.ipCountry)"></p>
        <div class="contacts__main__items">
          <div class="contacts__main__items__item">
            <img src="@/assets/images/Contacts/internet.svg" alt="" />
            <p>rbxpier.me</p>
          </div>
          <div class="contacts__main__items__item">
            <img src="@/assets/images/Contacts/support.svg" alt="" />
            <p>EPIK582@gmail.com</p>
          </div>
          <div class="contacts__main__items__item">
            <img src="@/assets/images/Contacts/vk.svg" alt="" />
            <p>vk.com/ROBUXPIER</p>
          </div>
        </div>
      </div>
    </div>
    <!--    <Footer />-->
  </div>
</template>

<script>
import './contacts.scss'

import Navigation from '@/components/Navigation/Navigation'

import ipUtil from '@/utils/ip'

export default {
  name: 'Contacts',
  components: {
    Navigation
  },
  methods: {
    isCountryFromRu(c) {
      return ipUtil.isCountryInRuRegion(c)
    },
    isCountryRu(c) {
      return ipUtil.isCountryRu(c)
    }
  }
}
</script>
